<!-- <p>pending-host-approvals works!</p> -->
<div
  [ngClass]="{
    'visitor-pending-approvals-container':
      screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,

    'visitor-pending-approvals-container-mobile':
      screenInfo == ScreenType.Mobile
  }"
>
  <div
    [ngClass]="{
      'visitor-pending-header':
        screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,

      'visitor-pending-header-mobile': screenInfo == ScreenType.Mobile
    }"
  >
    <h5>Pending visitor approvals</h5>
    <!-- <button  mat-raised-button><b>X</b></button> -->
    <button mat-mini-fab (click)="onClose()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div class="visitor-pending-button-container">
    <div>
      <mat-form-field subscriptSizing="dynamic" appearance="outline">
        <mat-label>Choose Type</mat-label>
        <mat-select (selectionChange)="onChooseTypeChange($event)" value="2">
          <mat-option value="0">All</mat-option>
          <mat-option value="1">Approved</mat-option>
          <mat-option value="2">Pending</mat-option>
          <mat-option value="3">Rejected</mat-option>
          <mat-option value="4">Auto-Rejected</mat-option>
          <mat-option value="5">Pre-Approved</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div
    *ngIf="screenInfo != ScreenType.Mobile"
    [ngClass]="{
      'visitors-pending-table':
        screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
    }"
  >
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef>No.</th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>
      <ng-container matColumnDef="visname">
        <th mat-header-cell *matHeaderCellDef>Visitor Name</th>
        <td mat-cell *matCellDef="let row">
          {{ row.firstName + " " + row.lastName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="hostname">
        <th mat-header-cell *matHeaderCellDef>Host Name</th>
        <td mat-cell *matCellDef="let row">
          {{ row.hostName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Visit Date & Time</th>
        <td mat-cell *matCellDef="let row">
          {{
            getFormatedDate(row.visitDateTime) | date : "MMM dd, yyyy, h:mm a"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Details">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">
          Refresh
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            [disabled]="element.securityStatus == 1"
            (click)="onShowDetails(element)"
            mat-raised-button
          >
            <mat-icon *ngIf="expandedDetail != element.visitorID && false"
              >add</mat-icon
            >
            <mat-icon>refresh</mat-icon>
            <mat-icon
              *ngIf="
                showWaitingSection &&
                expandedDetail == element.visitorID &&
                false
              "
              >remove</mat-icon
            >
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="purpose">
        <th mat-header-cell *matHeaderCellDef>Purpose</th>
        <td mat-cell *matCellDef="let row">
          {{ row.purpose ? row.purpose : "Not Mentioned" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="security">
        <th mat-header-cell *matHeaderCellDef>Host Approval</th>
        <td mat-cell *matCellDef="let row">
          <button
            [ngStyle]="
              row.securityStatus == 1
                ? { 'background-color': 'green' }
                : row.securityStatus == -1 || row.securityStatus == 3
                ? { 'background-color': '#FFBF00' }
                : { 'background-color': 'red' }
            "
            class="security-button"
            mat-raised-button
          >
            {{
              row.securityStatus == -1
                ? "Rejected"
                : row.securityStatus == 1 && row.isPreApproved != "true"
                ? "Approved"
                : row.securityStatus == 1 && row.isPreApproved == "true"
                ? "Pre-Approved"
                : row.securityStatus == 3
                ? "Auto Rejected"
                : row.securityStatus == 0 && row.isPreApproved == "true"
                ? "Pre-Approved"
                : "Pending"
            }}
          </button>
          <button
            (click)="openApprovalPage(row)"
            class="security-button-temp"
            *ngIf="
              (row.securityStatus == 3 || row.securityStatus == 0) &&
              isOpenApprovalSection(row) &&
              row.isGateEntry == 1 &&
              row.isPreApproved != 'true'
            "
            mat-icon-button
            matTooltip="Open approval section"
          >
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Visit Time
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.visitDateTime | date : "hh:mm a" }}
        </td>
      </ng-container>
      <tr
        class="table-header"
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div
    *ngIf="screenInfo === ScreenType.Mobile"
    class="visitors-pending-table-mobile"
  >
    <div *ngIf="dataSource?.length == 0" class="preview-content-empty">
      No Visitors
    </div>
    <div *ngIf="dataSource?.length != 0">
      <app-mobile-table-card
        [visitorTableData]="dataSource"
        [tableType]="'pendingVisitor'"
        (showDetails)="openApprovalPage($event)"
      >
      </app-mobile-table-card>
    </div>
  </div>
</div>
